import { ReportModalBean } from "../../report/ReportModalBean";
import exportTemplate from './exportComponent.html';
import { ExportModalBean } from "../../export/ExportModalBean";
import { downloadSettingsValueKey } from "fides-angularjs-components/src/fts-administration/fts-exportDownload-settings/fts-download-settings";
import { EXPORT_TYPE } from "../../export/ExportModalController";
import { USERREPORT_ACCOUNTROUTE } from "../../../views/accounts/AccountController";
import { AccountsController } from "../accounts/accountsView.directive";
import { statementOptions, valueSeriesOptions } from "../../../views/administration/userReports/UserReportDetailDialogController";
import { ValueSeriesController } from "../../../views/valueseries/valueseries";
import moment from "moment";
import { accounts, USER_ACC, VALUE_SERIES } from '../../../services/arsweb/RoutingPaths';
import { EXPORT_MODAL } from "../../../routes/export.route";

/** @ngInject */
export function groupsExportComponent() {
    return {
        restrict: 'E',
        scope: {
            parentController: '=',
            hooverText: '@',
            rowNodeId: '@',
            withDownload: '=',
            withExport: '=',
            exportText: '='
        },
        templateUrl: exportTemplate,
        controller: GroupsExportController,
        controllerAs: 'exportController'
    };
}

/** @ngInject */
export class GroupsExportController {
    constructor($scope, $rootScope, arsMainDependencies) {
        this.maxAccounts = arsMainDependencies.ArsConfig.MAX_ACCOUNTS;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        delete this.$rootScope.tables;
        this.$mdDialog = arsMainDependencies.$mdDialog;
        this.state = arsMainDependencies.$state;
        this.exportText = $scope.exportText || 'EXPORT_CSV_HOOVER';

        this.REPORT_MODAL = {
            templateUrl: 'app/components/report/report-modal.html',
            controller: 'ReportModalController',
            controllerAs: 'vm',
            size: 'md',
            backdrop: 'static',
            keyboard: false,
            multiple: true,
            resolve: { reportModalBean: () => new ReportModalBean(this.$scope.parentController.supportedReports,
                    this.$scope.parentController.withDateRange, this.$scope.parentController.withLastAndUnread) }
        };

        this.USERREPORTSTATE = this.state.get(USERREPORT_ACCOUNTROUTE);
        this.USER_REPORT_MODAL = {
            templateUrl: this.USERREPORTSTATE.templateUrl,
            controller: this.USERREPORTSTATE.controller,
            controllerAs: this.USERREPORTSTATE.controllerAs,
            backdrop: 'static',
            keyboard: false,
            multiple: true
        };

        let totalElements = 0;
        $scope.$on('populated', (event, params) => {
            totalElements = totalElements + params.length;
            // different multiple selection on different groups selection
            this.state._params.ids = this.state._params.ids ?
                this.state._params.ids.concat(params) : params;
            // opens only one user report at a time
            if(params.tableId){  // called for reporting on table group level component
                this.showAndResetUserReport();
            }
        });
    }

    checkSelectedIems(isReport) {
        this.$rootScope.checkElements = 0;
        this.dataPromises = [];
        this.state._params = {ids:[]};
        if(this.$rootScope.tables) {
            this.$rootScope.tables.filter(t => !_.isNil(t.getSelectedNodes()))
                .forEach(t => {
                    if(!t.isAllSelected) {
                        this.$rootScope.checkElements = (this.$rootScope.checkElements || 0) +  t.getSelectedNodes().length;
                        const selIds =  t.getSelectedNodes().map(node => node.data[this.$scope.rowNodeId]);
                        if(selIds){
                            this.state._params.ids = selIds ? this.state._params.ids.concat(selIds) : selIds;
                        }
                    } else {

                        if(this.$scope.parentController instanceof ValueSeriesController) {
                            const dateRange = this.$rootScope.dateFilter.dateRange;
                            const diffDays = moment(dateRange.upperBound).diff(moment(dateRange.lowerBound), 'days', true);
                            const totalAccounts = t.paginationGetRowCount() / (Math.round(diffDays) + 1);
                            t.total = totalAccounts;
                            this.$rootScope.checkElements = (this.$rootScope.checkElements || 0) + totalAccounts;
                        } else {
                            t.total = t.paginationGetRowCount();
                            this.$rootScope.checkElements = (this.$rootScope.checkElements || 0) + t.paginationGetRowCount();
                        }
                    }
                });

            // check there's selection
            if(this.$rootScope.checkElements === 0 ){
                this.$scope.parentController.infoPop('NO_ROW_SELECTED');
                return false;
            }

            if(isReport) {
                // max num of accounts only for reports
                if(this.$rootScope.checkElements > this.maxAccounts) {
                    this.$scope.parentController.infoPop(
                        this.$scope.parentController.translate.instant('ACCOUNT_REPORT_LIMIT',
                            {rowsLimit: this.maxAccounts, rowsCounter: this.$rootScope.checkElements}));
                    return false;
                } else {
                    this.getReportAccountsData();
                }
            }

            return true;
        }

        this.$scope.parentController.infoPop('NO_ROW_SELECTED');
        return false;
    }

    getReportAccountsData() {
        if(this.$rootScope.tables) {
            const backendService = this.$scope.parentController.getUserAccountBackendService(this.$scope.parentController.userService);
            const url = this.$scope.parentController instanceof ValueSeriesController ?
                USER_ACC + VALUE_SERIES + accounts : USER_ACC + accounts;
            // get acc. for indev. selected ids
            if(!_.isNil(this.state._params.ids) && this.state._params.ids.length > 0){
                backendService.resetPaging(this.state._params.ids.length);
                this.dataPromises.push(backendService.postUserData(url,{loadKey: this.state._params.ids}));
            }
            // get acc. for selection all
            this.$rootScope.tables
                .filter(t => !_.isNil(t.getSelectedNodes()) && t.isAllSelected)
                .forEach(t => {
                    backendService.resetPaging(t.total);
                    backendService.service.config.params.sort = t.sort;
                    t.tableFilter = t.constructTableFilter();
                    this.dataPromises.push(backendService.postUserData(url, t.tableFilter));
                });
        }
    }

    checkExport() {
        const userSettings = this.$scope.parentController.sessionPersistance.get(downloadSettingsValueKey);
        const exportFormat = userSettings ? userSettings.exportFormat : 'SETTINGS_EXPORTFORMAT_OPTION_NONE';

        this.$rootScope.exportFromGroup = false;
        if(exportFormat === 'SETTINGS_EXPORTFORMAT_OPTION_NONE') {
            this.openExport();
        } else {
            this.broadcastOption(
                exportFormat === 'SETTINGS_EXPORTFORMAT_OPTION_CSV' ? EXPORT_TYPE.CSV : EXPORT_TYPE.XLS);
        }
    }

    openExport() {
        // delete possible group definition
        EXPORT_MODAL.resolve = {
            exportModalBean: () => new ExportModalBean(this.$scope.parentController.supportedExports,{ }, undefined)
        };
        this.openPopup(EXPORT_MODAL);
    }

    openReport() {
        if(this.checkSelectedIems(true)) {
            // accounts & val series report
            if(this.$scope.parentController instanceof AccountsController ||
                this.$scope.parentController instanceof ValueSeriesController) {
                this.state._params.consolitationcurrency = this.$scope.parentController.$scope.consolidationCurrency;
                this.state._params.fileType = this.$scope.parentController instanceof AccountsController ?
                    statementOptions : valueSeriesOptions;
                this.state._params.selectAll = this.$rootScope.selectAll;
                this.state._params.tableFilter = this.$rootScope.tableFilter;
                // select All option
                if(this.state._params.selectAll) {
                    this.state._params.tableFilter = this.$rootScope.tableFilter;
                    this.state._params.tableCount = this.$rootScope.tableCount;
                }
                if(!_.isNil(this.dataPromises)){
                    this.state._params.ids = [];
                    Promise.all(this.dataPromises).then((data)=> {
                        if(data) {
                            this.state._params.ids = data.flat(1);
                            this.showAndResetUserReport();
                        }
                    });
                } else {
                    this.showAndResetUserReport();
                }
            } else { // Statements, intradays, transactions.. report
                this.openPopup(this.REPORT_MODAL);
            }
        }
    }

    showAndResetUserReport() {
        this.$mdDialog.show(this.USER_REPORT_MODAL).catch(() => {
            // reset for next selection
            this.$rootScope.checkElements = 0;
            this.state._params.ids = [];
        });
    }

    openPopup(popUpOption) {
        if(this.checkSelectedIems(false)) {
            this.$mdDialog.show(popUpOption).catch(() => {});
        }
    }

    broadcastOption(selectedExport){
        this.$rootScope.$broadcast('export', {reportType: selectedExport, userFunction: selectedExport.userFunction });
    }
}
